var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmoji2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8896 32C25.7262 32 32.8896 24.8366 32.8896 16C32.8896 7.16344 25.7262 0 16.8896 0C8.05309 0 0.889648 7.16344 0.889648 16C0.889648 24.8366 8.05309 32 16.8896 32Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8901 18.6665C13.6696 18.6665 11.5327 18.2914 8.89008 17.7776C8.28653 17.6612 7.1123 17.7776 7.1123 19.5554C7.1123 23.111 11.1967 27.5554 16.8901 27.5554C22.5825 27.5554 26.6679 23.111 26.6679 19.5554C26.6679 17.7776 25.4936 17.6603 24.8901 17.7776C22.2474 18.2914 20.1105 18.6665 16.8901 18.6665Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88965 19.5557C8.88965 19.5557 11.5563 20.4446 16.8896 20.4446C22.223 20.4446 24.8896 19.5557 24.8896 19.5557C24.8896 19.5557 23.1119 23.1112 16.8896 23.1112C10.6674 23.1112 8.88965 19.5557 8.88965 19.5557Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5572 15.1114C12.7845 15.1114 13.7794 13.7185 13.7794 12.0003C13.7794 10.2821 12.7845 8.88916 11.5572 8.88916C10.3299 8.88916 9.33496 10.2821 9.33496 12.0003C9.33496 13.7185 10.3299 15.1114 11.5572 15.1114Z",
    fill: "#664500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2212 15.1114C23.4485 15.1114 24.4435 13.7185 24.4435 12.0003C24.4435 10.2821 23.4485 8.88916 22.2212 8.88916C20.9939 8.88916 19.999 10.2821 19.999 12.0003C19.999 13.7185 20.9939 15.1114 22.2212 15.1114Z",
    fill: "#664500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji2);
export default __webpack_public_path__ + "static/media/emoji2.8709941b28a8208d1cb7a8da5a82de41.svg";
export { ForwardRef as ReactComponent };